import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../../core/i18n";

export function ShareButton(props: { shareState : any, clicked : () => void }) {
  const shareButtonClicked = () => {
    props.clicked();
  }

  if (props.shareState?.sharingStatus === "private") {
    return (<div className="d-grid mb-1">
      <hr />
      <button id="modal-success" type="button" className="btn btn-success btn-block" onClick={shareButtonClicked}>
        <FontAwesomeIcon icon="check" />&nbsp; {translate("share-status-action")}
      </button>
    </div>
    );
  } else if (props.shareState?.sharingStatus === "public") {
    return (<div className="d-grid gap-2">
      <hr />
      <button id="modal-success" type="button" className="btn btn-danger btn-block" onClick={shareButtonClicked}>
        <FontAwesomeIcon icon="check" />&nbsp; {translate("share-status-public-action")}
      </button>
    </div>
    );
  }
  return null;
}
